import type { TFunction } from "i18next";

import type { Question } from "../../helpers";

/**
 * Gets the translated title for a health report question
 * Handles special cases like neck pain and FES questionnaires
 *
 * @param question - The question object
 * @param t - Translation function from i18next
 * @param painLocation - Patient's pain location for dynamic text
 * @returns Translated question title
 */
export const getReportQuestionTitle = (question: Question, t: TFunction, painLocation?: string): string => {
  // Special case for neck pain regular activities question
  // TODO: Delete this when this translation supports ICU
  // See: https://jointacademy.atlassian.net/browse/CCC-1180
  if (painLocation === "neck" && question.key === "oa_regular_activities_effect") {
    return t("patients.health_reports.questions_content.oa_regular_activities_effect_neck");
  }

  // If question has dynamic parameters (e.g., painLocation, joint)
  if (question.params) {
    return t(
      // FIXME: type translation
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      `patients.health_reports.questions_content.${question.title_key ? question.title_key : question.key}`,
      question.params
    );
  }

  // Special case for FES questionnaires
  if (question.type === "fes") {
    // FIXME: type translation
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return t(`patients.health_reports.questions_content.fes_hq.${question.key}`);
  }

  // Default translation
  // FIXME: type translation
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return t(`patients.health_reports.questions_content.${question.title_key ? question.title_key : question.key}`);
};
